import { ECheckMode } from '../../enums/ECheckMode';
import { IValueData, IBaseProps } from '../../types/data';
import { IOYTab } from '../OYTab/const';

export interface IOYCategoryTabProps extends IBaseProps {
  /**
   * 是否支持在初始行显示搜索框
   */
  flatSearch?: boolean;
  /**
   * 初始行展示类型
   */
  display?: 'card' | 'text';
  /**
   * 切换分类文本
   */
  cateBtnText?: string;
  /**
   * 列数
   */
  cells?: number;
  /**
   * 每列宽度
   */
  width?: number;
  /**
   * 文本最大长度
   */
  maxTextLength?: number;
  /**
   * 选中值
   */
  value: string[];
  /**
   * 数据
   */
  info: IOYCategoryTabInfo[];
  /**
   * 特殊业务逻辑字段. 牌号模糊搜索
   * TODO:这个最好是剥离吹起
   */
  shopSignLike?: string;
  /**
   * 制定如何排序
   */
  flatSort?: (m: IOYCategoryTabInfoInfo, n: IOYCategoryTabInfoInfo) => number;
  /**
   * 控制如何渲染flatItem
   */
  renderFlatItem?: (data: IOYCategoryTabInfoInfo) => string;
}

export interface IOYCategoryTabState {
  expand: boolean;
  check: boolean;

  checkboxOption: {
    box: boolean,
    mode: ECheckMode
  };
  tags: IOYCategoryTabInfoInfo[];
  checkType: ECheckType;

  curretTabKey: string;
  letterTabKey: string;
  tabs: (IOYTab & { info: any[] })[];
  width: string;
  titleWidth: string;
  contentWidth: string;
  letterMap: ILetterMap[];
  flatData: IOYCategoryTabInfoInfo[];
  inputValue: string;
}

export interface ILetterMap extends IOYTab {
  info: IOYCategoryTabInfoInfo[]
}

export interface IOYCategoryTabInfo {
  name: string;
  info: {
    name: string;
    value: string;
    info: IOYCategoryTabInfoInfo[]
  }[]
}

export interface IOYCategoryTabInfoInfo extends IValueData {
  letters: string;
  checked: boolean;
  [i: string]: any
}

export enum ECheckType {
  Category,
  Letter,
}



// WEBPACK FOOTER //
// ./src/components/OYCategoryTab/const.ts